<bp-spinning-logo></bp-spinning-logo>
